
<!-- QuickPlan Main -->
<template>
    <div>
        <Terms></Terms>
        <transition mode="out-in"
                    enter-active-class="animated fadeIn fast"
                    leave-active-class="animated fadeOut fast">
            <div class="guide_main" style="max-width:1060px;margin:0 auto;">
                <div class="img_wrapper" style="
                            height: 360px!important;
                            overflow:hidden;position: fixed!important;
                            left: 0!important;
                            top: 48px!important;
                            width: 100%;!important">
                    <img style="margin:-21.875% 0;"
                         src="https://www.onead.com.tw/wp-content/uploads/2017/06/werghwghrgrg.jpg?id=21487" alt="">
                </div>
                <el-row class="guide_title guide_start">
                    <el-col :span="20" :offset="2">
                  <span style="font-size:32px;width:100%;text-align:center; display: inline-block;">QuickPlan AI受眾觸及規劃師 </span>
                        <br>
                        <!-- <span style="width:100%;text-align:left;
              display: inline-block;margin-bottom:0px;"></span> -->
                        <br>
                        您可透過 QuickPlan 統一整合受眾數據(包括：受眾輪廓、量體預估、預算建議…等等)，
                        <br>
                        擬定符合廣告目的與目標受眾的最佳規劃，
                        <!-- <br> -->
                        幫助您的每一分預算達到最大效益。
                    </el-col>
                </el-row>

                <el-row :gutter="24">
                    <el-col :span="7" :offset="1">
                        <router-link :to="ROUTE_PATH.GUIDE.PURPOSE + '1'">
                            <div class="action_select">
                                <span class="option_item_icon">
                                    <i class="fas fa-bullseye"></i>
                                </span>
                                <span class="option_item_text">廣告活動目的</span>
                                <span class="option_item_discription">
                                  規劃最適合您的廣告目的之格式運用、受眾設定、預算配置等等。
                                </span>
                                <el-button type="primary">開始規劃</el-button>
                            </div>
                        </router-link>
                    </el-col>
                    <el-col :span="7">
                        <router-link :to="ROUTE_PATH.GUIDE.AUDIENCE + '1'">
                            <div class="action_select">
                                <span class="option_item_icon">
                                    <i class="far fa-address-card"></i>
                                </span>
                                <span class="option_item_text">受眾輪廓洞察</span>
                                <span class="option_item_discription">掌握您的目標受眾之輪廓樣貌。</span>
                                <el-button type="primary">探索報告</el-button>
                            </div>
                        </router-link>
                    </el-col>
                    <el-col :span="7">
                        <router-link :to="ROUTE_PATH.CALCULATION">
                            <div class="action_select">
                                <span class="option_item_icon">
                                    <i class="far fa-file-video"></i>
                                </span>
                                <span class="option_item_text">觸及預估＆預算建議</span>
                                <span class="option_item_discription">
                                  快速計算自訂目標受眾之人數、觸及佔比、建議預算等等。
                                </span>
                                <el-button type="primary">開始計算</el-button>
                            </div>
                        </router-link>
                    </el-col>
                </el-row>
                <el-row class="guide_title guide_start" style="color:#4a4a4a;font-size:16px;">
                    <el-col :span="24">
                        OneAD 跨網覆蓋99.8％全台上網人口，
                        <!-- <br> -->
                        始終堅持以『跨』的理念－跨媒體、跨裝置、

                        跨串流、跨買法、跨應用、跨數據來源－<br>打破資料隔閡(silo)，
                        <!-- <br> -->
                        發揮數據的最大價值，零時差掌握全面深度的受眾洞察。
                    </el-col>
                </el-row>
            </div>
        </transition>
        <Copyright></Copyright>
    </div>
</template>

<script>
// import animate from 'animate.css'
// import router from './router'
import { ROUTE_PATH } from '../../router/Const'
import Copyright from '@/views/Guide/components/Copyright'
import Terms from '@/views/terms.vue'

export default {
  components: { Copyright, Terms },
  data () {
    return {
      active: 0,
      ROUTE_PATH
    }
  }
}
</script>

<style lang="scss">
.guide_title.guide_start{
    // 這個暫時的
    font-size: 18px;
    text-align:center;
    margin:24px 0 12px;
    line-height: 1.5;
    color:#fff;
}
a{
    text-decoration: unset;
}

.el-aside.sidebar.hide{
    display:none;
}
.action_select{
    font-size:20px;
    height:360px;
    text-decoration: none;
    flex-direction: column;
    padding: 24px;
    color: #4a4a4a;
    font-weight: normal;
    justify-content: flex-start;
    text-align: center;
    margin: 20px auto 0px;
    box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    background-color: #ffffff;
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    line-height: 1.5;
    transition: 0.5s;
    cursor: pointer;
    overflow: hidden;
    position: sticky;
}
.action_select .option_item_text{
    flex-grow: unset;
    text-decoration: unset;
    margin:16px 0;
    font-weight:bold;
    font-size:24px;
}
.action_select .option_item_icon{
    margin: 0;
    font-size:72px;
}
.el-col:nth-child(1) .action_select .option_item_icon{
    color:#4da1ff;
}
.el-col:nth-child(2) .action_select .option_item_icon{
    color: #ffb53a;
}
.el-col:nth-child(3) .action_select .option_item_icon{
    color:#11b9a1
}
.action_select .option_item_discription{
    font-size:16px;
    text-align: left;
    flex-grow: 1;
}
.action_select .el-button{
    width:100%;
}
</style>
